(function () {

  function isOptedIn(form) {
    return form.getAttribute("data-recaptcha-version") === "v3";
  }

  function hasRecaptchaInjected(form) {
    return !!(
      form.querySelector(".g-recaptcha") ||
      form.querySelector('[data-sitekey].g-recaptcha') ||
      form.querySelector('textarea[name="g-recaptcha-response"]')
    );
  }

  function attach(form) {
    form.addEventListener("submit", function (e) {

      if (!isOptedIn(form)) return;
      if (hasRecaptchaInjected(form)) return;

      var tokenField = form.querySelector('input[name="g-recaptcha-response"]');
      if (!tokenField) return;
 
      if (tokenField.value && tokenField.value.length > 10) return;

      if (form.__recaptchaV3Submitting) return;
      form.__recaptchaV3Submitting = true;

      e.preventDefault();

      if (!window.grecaptcha || !window.__recaptchaV3SiteKey) {
        console.warn("reCAPTCHA v3 not available");
        form.__recaptchaV3Submitting = false;
        form.submit();
        return;
      }

      var action = form.getAttribute("data-recaptcha-action") || "submit";

      grecaptcha.ready(function () {
        grecaptcha.execute(window.__recaptchaV3SiteKey, { action: action })
          .then(function (token) {
            tokenField.value = token;
            form.__recaptchaV3Submitting = false;
            form.submit();
          })
          .catch(function () {
            form.__recaptchaV3Submitting = false;
            form.submit();
          });
      });
    }, true);
  }

  var forms = document.querySelectorAll('form[data-recaptcha-version="v3"]');
  if (!forms.length) return;

  forms.forEach(attach);

})();
